import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardActionArea } from './PropertyCardActionArea.styles';

/**
 * A container for action buttons in a `PropertyCard`.
 *
 * @since 8.63.0
 */
export var PropertyCardActionArea = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardActionArea, _extends({
    ref: forwardedRef
  }, props));
});
PropertyCardActionArea.displayName = 'PropertyCard.ActionArea';